import { useEffect, useState } from 'react'
import type { JSX } from 'react'
import { describeError } from '../api/errors'
import { auth } from '../api/rooms'
import { navigate } from '../lib/router'

/** Вход автора. Участникам он не нужен — они входят в комнату по ссылке. */
export function LoginPage(): JSX.Element {
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [required, setRequired] = useState<boolean | null>(null)

  useEffect(() => {
    void auth
      .me()
      .then((state) => {
        setRequired(state.authRequired)
        if (state.isAdmin) navigate({ name: 'projects' })
      })
      .catch(() => setRequired(true))
  }, [])

  const submit = async (): Promise<void> => {
    setBusy(true)
    setError(null)
    try {
      await auth.login(password)
      navigate({ name: 'projects' })
    } catch (err) {
      setError(describeError(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="page narrow">
      <h1>Вход для автора</h1>
      {required === false ? (
        <p className="faint">
          Пароль не задан — сервер работает открыто. Чтобы закрыть редактор, запустите его
          с ключом <span className="mono">-admin-password</span>.
        </p>
      ) : (
        <p className="faint">
          Пароль защищает редактор, разбор и управление комнатами. Играть можно и без него.
        </p>
      )}
      <form
        className="login-form"
        onSubmit={(e) => {
          e.preventDefault()
          void submit()
        }}
      >
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Пароль"
          autoFocus
          aria-label="Пароль"
        />
        <button type="submit" className="primary" disabled={busy || !password}>
          {busy ? 'Проверяю…' : 'Войти'}
        </button>
      </form>
      {error ? <p className="error-text">{error}</p> : null}
      <button type="button" className="ghost" onClick={() => navigate({ name: 'games' })}>
        ← К списку озвучек
      </button>
    </div>
  )
}
